import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { MessageService } from 'primeng/api';
import { BehaviorSubject, Observable, Subject, catchError, takeUntil} from 'rxjs';
import { ServiceBase } from './servicebase.service';

@Injectable({
  providedIn: 'root'
})
export class AgencyService extends ServiceBase implements OnDestroy{

  public agenciesSubj: BehaviorSubject<ServerModels.ENESS_REF_Agency[]> = new BehaviorSubject([]);
  public agencies$: Observable<ServerModels.ENESS_REF_Agency[]> = this.agenciesSubj.asObservable();

  private _destroyed$: Subject<void> = new Subject();

  constructor(protected http: HttpClient,
    public messageService: MessageService) {

    super(http, messageService);

    if (!this.agenciesSubj.observed) {
      this.getAllAgencies().pipe(takeUntil(this._destroyed$)).subscribe((agencies: ServerModels.ENESS_REF_Agency[]) => {
        this.agenciesSubj.next(agencies);
      });
    }
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  public getAgenciesForState(stateId: string): Observable<ServerModels.ENESS_REF_Agency[]> {
    return this.http.get<ServerModels.ENESS_REF_Agency[]>(`${this.apiRoot}/api/Agency/AgenciesByStateId`, {
      headers: this.httpOptions['headers'],
      params: {
        stateId: stateId
      }
    }).pipe(catchError(this.swallowError<any>('getAgenciesForState', 'defaultMsg', null, null)));;
  }

  public getAllAgencies(): Observable<ServerModels.ENESS_REF_Agency[]> {
    return this.http.get<ServerModels.ENESS_REF_Agency[]>(`${this.apiRoot}/api/Agency/AllAgencies`, this.httpOptions).pipe(catchError(this.swallowError<any>('getAllAgencies', 'defaultMsg', null, null)));;
  }

  public getAllAgenciesToUpdate(onlyOrphan:boolean, filterModel: ServerModels.FiltersViewModel): Observable<ServerModels.UpdateAgencyViewModel[]> {
    return this.http.post<ServerModels.UpdateAgencyViewModel[]>(`${this.apiRoot}/api/Agency/GetAllAgenciesToUpdate?onlyOrphan=` + onlyOrphan, filterModel, this.httpOptions).pipe(catchError(this.throwError<any>('getAllAgenciesToUpdate', 'defaultMsg', null, null)));
  }

  public getFieldDivisionStateCounties(): Observable<ServerModels.FieldDivisionStateCountyViewModel[]> {
    return this.http.get<ServerModels.FieldDivisionStateCountyViewModel[]>(`${this.apiRoot}/api/Agency/GetFieldDivisionStateCounties`, this.httpOptions).pipe(catchError(this.swallowError<any>('getFieldDivisionStateCounties', 'defaultMsg', null, null)));
  }

  public addorUpdateAgency(agencyToAdd: ServerModels.ENESS_REF_Agency): Observable<ServerModels.UpdateAgencyViewModel> {
    return this.http.post<ServerModels.UpdateAgencyViewModel>(`${this.apiRoot}/api/Agency/AddOrUpdateAgency`, agencyToAdd, this.httpOptions).pipe(catchError(this.throwError<any>('addorUpdateAgency', null, null, null))); 
  }

  public mergeAgencyORINums(parentAgencyId: string, agencyId: string): Observable<ServerModels.UpdateAgencyViewModel> {
    let options = {
      headers: this.httpOptions.headers,
      params: {
        'parentAgencyId': parentAgencyId,
        'agencyId': agencyId
      }
    };
    return this.http.get<ServerModels.UpdateAgencyViewModel>(`${this.apiRoot}/api/Agency/MergeAgencyORINums`, options).pipe(catchError(this.swallowError<any>('mergeAgencyORINums', 'oriMergeMessage', null, null)));
  }

  public GetAgenciesForCurrentStateAndLocalUser(): Observable<ServerModels.AgencyViewModel[]> {
    return this.http.get<ServerModels.AgencyViewModel[]>(`${this.apiRoot}/api/Agency/GetAgenciesForStateAndLocalUser`, this.httpOptions).pipe(catchError(this.swallowError<any>('GetAgenciesForCurrentStateAndLocalUser', 'defaultMsg', null, null))); 
  }  

  public updateAgencyCDS(agencyToUpdate: ServerModels.UpdateAgencyViewModel): Observable<ServerModels.UpdateAgencyViewModel> {
    return this.http.post<ServerModels.UpdateAgencyViewModel>(`${this.apiRoot}/api/Agency/UpdateAgencyCDS`, agencyToUpdate, this.httpOptions).pipe(catchError(this.throwError<any>('updateAgencyCDS', 'defaultMsg', null, null)));
  }

  public getCDSData(): Observable<ServerModels.CDSDataSharingViewModel[]> {
    return this.http.get<ServerModels.CDSDataSharingViewModel[]>(`${this.apiRoot}/api/Agency/getCDSData`, this.httpOptions).pipe(catchError(this.swallowError<any>('getCDSData', 'defaultMsg', null, null))); 
  }
}
